/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportSnapshot = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 8.5A6.5 6.5 0 0 1 8.5 2c3.323 0 6.114 2.549 6.508 5.761l-1.985.244a4.415 4.415 0 0 0-.243-.997L7.5 9.607V4.112a4.502 4.502 0 0 0-2.17 7.583l-1.408 1.42A6.483 6.483 0 0 1 2 8.5zm7.5-4.386v2.28l2.182-1.074A4.609 4.609 0 0 0 9.5 4.114zM11.586 9h4.828l2 2H22v11H6V11h3.586zm.828 2-2 2H8v7h12v-7h-2.414l-2-2zM14 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReportSnapshot as ReportSnapshot };
